import React from 'react';
import { MOSQUE_FEATURES } from '../../utils/mosqueFeatures';

const MosqueFeaturesSection = ({
  mosque,
  values,
  editable = false,
  onToggle,
  className = '',
}) => {
  const source = editable ? values : mosque;

  return (
    <div className={`bg-white rounded-lg shadow-sm border p-6 mb-6 ${className}`.trim()}>
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Mosque Features</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {MOSQUE_FEATURES.map(({ key, label }) => {
          const enabled = !!source?.[key];
          if (editable) {
            return (
              <label
                key={key}
                className="flex items-center gap-2 cursor-pointer select-none"
              >
                <input
                  type="checkbox"
                  name={key}
                  checked={enabled}
                  onChange={(e) => onToggle?.(key, e.target.checked)}
                  className="h-4 w-4 rounded border-gray-300 text-green-600 focus:ring-green-500"
                />
                <span className="text-sm text-gray-700">{label}</span>
              </label>
            );
          }
          return (
            <div key={key} className="flex items-center gap-2">
              <div
                className={`w-3 h-3 rounded-full shrink-0 ${
                  enabled ? 'bg-green-500' : 'bg-gray-300'
                }`}
                aria-hidden
              />
              <span className="text-sm text-gray-700">{label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MosqueFeaturesSection;
